import { getLogger } from 'wanderu-logger';

const logger = getLogger('gtm-analytics');

const dataLayer = typeof window !== 'undefined'
    ? window.dataLayer
    : [];

/**
 * Push onto the GTM dataLayer, resolving it at call time.
 *
 * The `dataLayer` export above is bound once at module load, so it is
 * `undefined` for any bundle evaluated before the head snippet runs (and in
 * tests). Resolving per call -- and seeding the array when it is absent, the
 * same `w[l]=w[l]||[]` the snippet itself does -- means an early push is queued
 * for GTM to drain rather than dropped or thrown on.
 *
 * Write-only by contract: nothing here reads the array back, because wandroid's
 * WebView sink keeps it empty (wandroid#144).
 *
 * The push itself is guarded. GTM swaps `dataLayer.push` for its own function
 * that runs matching tags synchronously, so a broken tag or variable surfaces
 * here as a throw from what reads like an array append. Callers sit in a render
 * lifecycle (the search results list) and in the Book click ahead of the canopy
 * bridge's preventDefault, where an escaping error would unmount the results or
 * let the native <a href> carry the traveler to the wrong checkout. Analytics
 * never gets to break the page it measures.
 */
function pushToDataLayer(payload) {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    } catch (error) {
        logger.warn('dataLayer push failed', { error });
    }
}

export {
    dataLayer,
    pushToDataLayer,
};
